import React from "react"
import HeroSlides from "../components/hero-slides"
import Layout from "../components/layout"

import Footer from "../components/footer"

import SocialIconsFooter from "../components/social-icons-footer"

import Projects from "../components/projects"

const IndexPage = () => {
    return (
        <Layout
            pageTitle="PragICTS | Featured Projects"
        >
            <div id="wrapper">
                <div className="scroll-nav-wrap fl-wrap">
                    <div className="scroll-down-wrap">
                        <div className="mousey">
                            <div className="scroller"></div>
                        </div>
                        <span>Scroll Down</span>
                    </div>
                    <nav className="scroll-nav scroll-init">
                        <ul>
                            {/* <li><a className="scroll-link act-link" href="#sec1">Hero</a></li> */}
                            <li><a className="scroll-link" href="#overview">Overview</a></li>
                         
                            <li><a className="scroll-link" href="#projects">Projects</a></li>
                        
                        </ul>
                    </nav>
                </div>

                <HeroSlides />

                <div className="content">

                    {/* overview section */}
                    <Projects />
                 
                    

                    <SocialIconsFooter />
                </div>
                <Footer />
            </div>
        </Layout>
    )
}

export default IndexPage
